<style scoped>
.sub-th {
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
  font-size: 10px !important;
  white-space: nowrap;
}

.th-ellipsis {
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
.n-ellipsis {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
.th-ellipsis:hover {
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
  width: 100%;
}
.v-data-table-header-mobile {
  display: none !important;
}

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white;
}

.first-col {
  width: 75px;
  left: 0px;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
</style>

<template>
  <div>
    <!-- Add banner dialog -->
    <v-dialog v-model="dialog" max-width="400">
      <v-form ref="formInsert">
        <v-card>
          <v-card-title class="text-h6 d-flex justify-center">
            เพิ่มรูปภาพแบนเนอร์ <br />
            <div class="subtitle-1">
              (ขนาดรูปภาพต้องมีขนาด 1842 x 575 ขึ้นไป)
            </div>
          </v-card-title>
          <v-file-input
            outlined
            dense
            accept="image/*"
            label="เพิ่มรูปภาพ"
            @change="onFileChange"
            v-model="file"
            :rules="imageRules"
            class="mr-5"
          ></v-file-input>

          <v-card-actions>
            <v-spacer> </v-spacer>
            <v-btn class="color-button" @click="dialog = false"> ยกเลิก </v-btn>
            <v-btn class="color-buttonConfirm mr-3" @click="confirmSaveBanner">
              ยืนยัน
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <div class="mt-n8 mb-3 ml-6" style="font-size: 1.35rem" color="blue">
      <div style="display: flex; justify-content: space-between">
        <div>รายการแบนเนอร์</div>
        <div>
          <v-btn color="success" width="100%" @click="addBanner"
            ><v-icon>mdi-plus</v-icon> เพิ่มแบนเนอร์
          </v-btn>
        </div>
      </div>
      <v-divider class="my-3"></v-divider>
      <v-row justify="center">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items-per-page="15"
            class="elevation-2"
            :items="BannerData"
          >
            <template #[`item.FILE_URL`]="{ item }">
              <v-img width="400px" height="120px" :src="item.FILE_URL"></v-img>
            </template>

            <template #[`item.FILE_NAME`]="{ item }">
              <div class="text-truncate" style="max-width: 100px">
                {{ item.FILE_NAME }}
              </div>
            </template>
            <template #[`item.CREATE_DATE`]="{ item }">
              <div class="text-truncate" style="max-width: 100px">
                {{ item.CREATE_DATE | filterDate }}
              </div>
            </template>

            <template #[`item.ACTION`]="{ item }">
              <div class="d-flex justify-center">
                <v-btn
                  class="mx-1"
                  text
                  color="default"
                  @click="remove(item.ID, item.FILE_NAME)"
                >
                  <v-icon> mdi-trash-can-outline </v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table></v-col
        ></v-row
      >
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      headers: [
        { text: "รูปภาพ", value: "FILE_URL", align: "start" },
        { text: "ชื่อรูปภาพ", value: "FILE_NAME", align: "start" },
        { text: "วันที่เพิ่ม", value: "CREATE_DATE", align: "start" },
        { text: "จัดการข้อมูล", value: "ACTION", align: "center" },
      ],
      dialog: false,
      imageRules: [(v) => !!v || "กรุณากรอกเพิ่มรูปภาพ"],
      file: null,
      BannerData: [],
      PICTURE_URL: null,
    };
  },

  created() {
    this.listBanner();
  },

  filters: {
    filterDate(data) {
      return moment(data).add("y", 543).format("DD/MM/YYYY");
    },
  },

  methods: {
    async addBanner() {
      this.dialog = true;
    },

    remove(id, name) {
      this.$swal({
        title: "ต้องการลบข้อมูลหรือไม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          this.$token_api
            .delete("/deletebanner", {
              data: {
                ID: id,
                FILE_NAME: name,
              },
            })
            .then((response) => {
              this.listBanner();
              this.$swal({
                title: "ลบข้อมูลสำเร็จ",
                icon: "success",
                showCancelButton: false,
              });
            })
            .catch(function (error) {});
        }
      });
    },

    listBanner() {
      this.$token_api
        .get("/banner")
        .then((res) => {
          const result2 = res.data.data;
          this.BannerData = result2;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async onFileChange(event) {
      this.file = event;
      this.PICTURE_URL = event;

      if (this.file && this.file.type.startsWith("image/")) {
        const img = new Image();

        // Load the image to get its dimensions
        img.onload = () => {
          const width = img.width;
          const height = img.height;

          // Check if image dimensions are lower than the threshold
          if (width < 1842 || height < 575) {
            this.$swal.fire({
              icon: "error",
              title: "ขนาดรูปเล็กเกินไป",
              text: "ขนาดรูปภาพต้องมีขนาด 1842 x 575 ขึ้นไป",
            });
            this.file = null;
          }
        };
        img.src = URL.createObjectURL(this.file);
      }
    },

    async confirmSaveBanner() {
      const data = new FormData();
      data.set("files", this.file);

      console.log(data);

      if (!this.$refs.formInsert.validate()) {
        this.$swal({
          icon: "warning",
          title: "กรุณาเพิ่มรูปภาพแบนเนอร์",
        });
      } else {
        this.$token_api.post("/insertbanner", data).then((res) => {
          this.$swal({
            position: "center",
            icon: "success",
            title: "บันทึกสำเร็จ",
            showConfirmButton: false,
            timer: 1500,
          });
          this.listBanner();
          this.dialog = false;
          this.file = null;
          this.$refs.formInsert.reset();
        });
      }
    },
  },
};
</script>

